export const INSURANCE_SHIELD_ICON = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 64 64"
  fill="none"
>
  <path
    d="M32 7L52 14.5V29C52 41.5 44.5 51 32 57C19.5 51 12 41.5 12 29V14.5L32 7Z"
    stroke="currentColor"
    stroke-width="4.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />

  <path
    d="M27.5812 29.9875C30.0218 27.5471 33.9783 27.5471 36.419 29.9875L38.5909 32.1594C39.4693 33.038 39.4695 34.4624 38.5909 35.341C37.7123 36.2195 36.288 36.2194 35.4093 35.341L33.2374 33.1691C32.5541 32.4861 31.4461 32.4861 30.7628 33.1691L28.5909 35.341C27.7123 36.2196 26.288 36.2195 25.4093 35.341C24.5306 34.4623 24.5306 33.038 25.4093 32.1594L27.5812 29.9875Z"
    fill="currentColor"
  />

  <g fill="currentColor">
    <circle cx="24.75" cy="27.75" r="2.25" />
    <circle cx="39.25" cy="27.75" r="2.25" />
    <circle cx="29.25" cy="24.25" r="2.25" />
    <circle cx="34.75" cy="24.25" r="2.25" />
  </g>
</svg>
`;
